import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {StorageService} from '@services/storage.service';
import {Router} from '@angular/router';

@Component({
	selector: 'app-footer-cannes',
	templateUrl: './footer-cannes.component.html',
	styleUrls: ['./footer-cannes.component.scss']
})
export class FooterCannesComponent implements OnInit {
	@Input() currentLang: string;

	@Output() setLang: EventEmitter<string> = new EventEmitter<string>();

	showCookies: boolean = true;

	constructor(private storageService: StorageService,
				private router: Router) {
	}

	ngOnInit(): void {
	}


	urlGCS(): void {
		(window as any).open('https://www.ginko.voyage/cgv/', '_blank');
	}

	urlPrivacyPolicy(): void {
		this.router.navigate(['/auth/privacy']);
	}

	urlLegalNotice(): void {
		this.router.navigate(['/secured/mention']);
	}

	urlGinko(): void {
		(window as any).open('https://www.palmbus.fr/', '_blank');
	}

	acceptCookies() {
		this.storageService.setValue('cookies', 'accept');
		this.showCookies = false;
	}

}
